import { IntegrityMonitorRulesSmartViewsWebComponent } from './component/IntegrityMonitorRulesSmartViewsWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_SMART_VIEWS } from '../../../webcomponents.constants';

export { IntegrityMonitorRulesSmartViewsWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_SMART_VIEWS,
  IntegrityMonitorRulesSmartViewsWebComponent
);
